import { render } from "./BaseTagStatus.vue?vue&type=template&id=3dd5169e"
import script from "./BaseTagStatus.vue?vue&type=script&lang=js"
export * from "./BaseTagStatus.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3dd5169e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dd5169e', script)) {
    api.reload('3dd5169e', script)
  }
  
  module.hot.accept("./BaseTagStatus.vue?vue&type=template&id=3dd5169e", () => {
    api.rerender('3dd5169e', render)
  })

}

script.__file = "src/ui/tickets/BaseTagStatus.vue"

export default script